var items = {
  "block.minecraft.air": "ikuku",
  "block.minecraft.stone": "nkume",
  "block.minecraft.granite": "granite",
  "block.minecraft.polished_granite": "granite mara mma",
  "block.minecraft.diorite": "diorite",
  "block.minecraft.polished_diorite": "diorite gbagoro",
  "block.minecraft.andesite": "andesite",
  "block.minecraft.polished_andesite": "andesite a na-egbu egbu",
  "block.minecraft.grass_block": "ogwe ahịhịa",
  "block.minecraft.dirt": "unyi",
  "block.minecraft.coarse_dirt": "onu unyi",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "crimson nylium",
  "block.minecraft.warped_nylium": "nylium anwụọ",
  "block.minecraft.cobblestone": "nkịtị",
  "block.minecraft.oak_planks": "akpu atụmatụ",
  "block.minecraft.spruce_planks": "ekepu atụmatụ",
  "block.minecraft.birch_planks": "birch atụmatụ",
  "block.minecraft.jungle_planks": "ubi atụmatụ",
  "block.minecraft.acacia_planks": "acacia atụmatụ",
  "block.minecraft.dark_oak_planks": "itiri akpu atụmatụ",
  "block.minecraft.crimson_planks": "crimson planks",
  "block.minecraft.warped_planks": "planks warped",
  "block.minecraft.oak_sapling": "oak sapling",
  "block.minecraft.spruce_sapling": "spruce sapling",
  "block.minecraft.birch_sapling": "birch sapling",
  "block.minecraft.jungle_sapling": "sapling jungle",
  "block.minecraft.acacia_sapling": "acacia sapling",
  "block.minecraft.dark_oak_sapling": "ọchịchịrị oak sapling",
  "block.minecraft.bedrock": "bedrock",
  "block.minecraft.sand": "aja",
  "block.minecraft.red_sand": "uhie uhie",
  "block.minecraft.gravel": "ajịrịjaja",
  "block.minecraft.gold_ore": "gold ọlaedo",
  "block.minecraft.iron_ore": "ígwè ore",
  "block.minecraft.coal_ore": "coal ore",
  "block.minecraft.nether_gold_ore": "nether gold ore",
  "block.minecraft.oak_log": "akpu abanye",
  "block.minecraft.spruce_log": "abanye na spruce",
  "block.minecraft.birch_log": "abanye na birch",
  "block.minecraft.jungle_log": "abanye na ubi",
  "block.minecraft.acacia_log": "abanye na acacia",
  "block.minecraft.dark_oak_log": "itiri akpu abanye",
  "block.minecraft.crimson_stem": "crimson azuokokoosisi",
  "block.minecraft.warped_stem": "azuokokoosisi",
  "block.minecraft.stripped_oak_log": "akwụsịla akpu abanye",
  "block.minecraft.stripped_spruce_log": "akwụsịla ekepu abanye",
  "block.minecraft.stripped_birch_log": "akwụsịla birch abanye",
  "block.minecraft.stripped_jungle_log": "akwụsịla nnukwu ohia abanye",
  "block.minecraft.stripped_acacia_log": "akwụsịla acacia abanye",
  "block.minecraft.stripped_dark_oak_log": "akwụsịla itiri akpu abanye",
  "block.minecraft.stripped_crimson_stem": "tie crimson steeti",
  "block.minecraft.stripped_warped_stem": "pedzọ gbara ọgbọ afọ",
  "block.minecraft.stripped_oak_wood": "akwụsịla akpu osisi",
  "block.minecraft.stripped_spruce_wood": "akwụsịla ekepu osisi",
  "block.minecraft.stripped_birch_wood": "akwụsịla brich osisi",
  "block.minecraft.stripped_jungle_wood": "akwụsịla nnukwu ohia osisi",
  "block.minecraft.stripped_acacia_wood": "akwụsịla itiri akpu osisi",
  "block.minecraft.stripped_dark_oak_wood": "akwụsịla itiri akpu osisi",
  "block.minecraft.stripped_crimson_hyphae": "stickened crimson hyphae",
  "block.minecraft.stripped_warped_hyphae": "hypae stpedted warped",
  "block.minecraft.oak_wood": "osisi oak",
  "block.minecraft.spruce_wood": "spruce osisi",
  "block.minecraft.birch_wood": "osisi birch",
  "block.minecraft.jungle_wood": "osisi jungle",
  "block.minecraft.acacia_wood": "osisi acacia",
  "block.minecraft.dark_oak_wood": "osisi oak gbara ọchịchịrị",
  "block.minecraft.crimson_hyphae": "crimson hyphae",
  "block.minecraft.warped_hyphae": "hypae a lụrụ agha",
  "block.minecraft.oak_leaves": "oak doo",
  "block.minecraft.spruce_leaves": "spruce ahapụ",
  "block.minecraft.birch_leaves": "nnukwu birch",
  "block.minecraft.jungle_leaves": "oke oke osimiri",
  "block.minecraft.acacia_leaves": "acacia doo",
  "block.minecraft.dark_oak_leaves": "oak gbara ọchịchịrị",
  "block.minecraft.sponge": "ogbo",
  "block.minecraft.wet_sponge": "wet wet",
  "block.minecraft.glass": "iko",
  "block.minecraft.lapis_ore": "lapis lazuli ore",
  "block.minecraft.lapis_block": "ogwe lapis lazuli",
  "block.minecraft.dispenser": "dispensin",
  "block.minecraft.sandstone": "nkume aja",
  "block.minecraft.chiseled_sandstone": "chiseled sandstone",
  "block.minecraft.cut_sandstone": "bee nkume isi",
  "block.minecraft.note_block": "rịba ama block",
  "block.minecraft.powered_rail": "ilgbọ okporo ígwè kwadoro",
  "block.minecraft.detector_rail": "zọ nchọpụta detector",
  "block.minecraft.sticky_piston": "nkwụnye pistin",
  "block.minecraft.cobweb": "cobweb",
  "block.minecraft.grass": "ahịhịa",
  "block.minecraft.fern": "fern",
  "block.minecraft.dead_bush": "bush anwụ anwụ",
  "block.minecraft.seagrass": "oké ahịhịa",
  "block.minecraft.sea_pickle": "oké pikulu",
  "block.minecraft.piston": "pistin",
  "block.minecraft.white_wool": "white ajị",
  "block.minecraft.orange_wool": "oroma oroma",
  "block.minecraft.magenta_wool": "magenta wool",
  "block.minecraft.light_blue_wool": "uwe blue blue",
  "block.minecraft.yellow_wool": "ajị anụ edo edo",
  "block.minecraft.lime_wool": "wayo ajị",
  "block.minecraft.pink_wool": "pink ajị anụ",
  "block.minecraft.gray_wool": "acha ajị anụ",
  "block.minecraft.light_gray_wool": "ìhè gray ajị",
  "block.minecraft.cyan_wool": "nwa cyan",
  "block.minecraft.purple_wool": "acha purple",
  "block.minecraft.blue_wool": "blue ajị",
  "block.minecraft.brown_wool": "blue ajị",
  "block.minecraft.green_wool": "ajị anụ green",
  "block.minecraft.red_wool": "uhie uhie",
  "block.minecraft.black_wool": "nwa nwa ojii",
  "block.minecraft.dandelion": "dandelion",
  "block.minecraft.poppy": "poppy",
  "block.minecraft.blue_orchid": "blue orchid",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "azure bluet",
  "block.minecraft.red_tulip": "uhie tulip",
  "block.minecraft.orange_tulip": "oroma tulip",
  "block.minecraft.white_tulip": "na-acha ọcha tulip",
  "block.minecraft.pink_tulip": "pink tulip",
  "block.minecraft.oxeye_daisy": "oxeye daisy",
  "block.minecraft.cornflower": "ọka",
  "block.minecraft.lily_of_the_valley": "lily nke ndagwurugwu",
  "block.minecraft.wither_rose": "wither rose",
  "block.minecraft.brown_mushroom": "brown ero",
  "block.minecraft.red_mushroom": "toadstool",
  "block.minecraft.crimson_fungus": "crimson fungus",
  "block.minecraft.warped_fungus": "fungus nke gbachara agbacha",
  "block.minecraft.crimson_roots": "crimson roots",
  "block.minecraft.warped_roots": "mgbada ọgụ",
  "block.minecraft.nether_sprouts": "nkọwapụta netherland",
  "block.minecraft.weeping_vines": "ikwa vine",
  "block.minecraft.twisting_vines": "vine twist",
  "block.minecraft.sugar_cane": "okpete",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "achara",
  "block.minecraft.gold_block": "ngọngọ nke gold",
  "block.minecraft.iron_block": "ngọngọ nke iron",
  "block.minecraft.oak_slab": "akpu slab",
  "block.minecraft.spruce_slab": "ekepu slab",
  "block.minecraft.birch_slab": "brich slab",
  "block.minecraft.jungle_slab": "ubi slab",
  "block.minecraft.acacia_slab": "acacia slab",
  "block.minecraft.dark_oak_slab": "itiri akpu slab",
  "block.minecraft.crimson_slab": "crimson slab",
  "block.minecraft.warped_slab": "slab agha",
  "block.minecraft.stone_slab": "nkume nkume",
  "block.minecraft.smooth_stone_slab": "nkume na-agba ọcha",
  "block.minecraft.sandstone_slab": "okwute sandstone",
  "block.minecraft.cut_sandstone_slab": "bee nkume isi nkume",
  "block.minecraft.petrified_oak_slab": "na-ama jijiji akpu slab",
  "block.minecraft.cobblestone_slab": "okpokoro nkume",
  "block.minecraft.brick_slab": "biriiki slab",
  "block.minecraft.stone_brick_slab": "biriiki okute slab",
  "block.minecraft.nether_brick_slab": "nether brick slab",
  "block.minecraft.quartz_slab": "quartz slab",
  "block.minecraft.red_sandstone_slab": "nkume red sandstone",
  "block.minecraft.cut_red_sandstone_slab": "bee uhie uhie",
  "block.minecraft.purpur_slab": "purpur slab",
  "block.minecraft.prismarine_slab": "prismarine slab",
  "block.minecraft.prismarine_brick_slab": "biriiki prismarine slab",
  "block.minecraft.dark_prismarine_slab": "itiri prismarine slab",
  "block.minecraft.smooth_quartz": "gbochie quartz dị nro",
  "block.minecraft.smooth_red_sandstone": "ezigbo red sandstone",
  "block.minecraft.smooth_sandstone": "ezigbo sandstone",
  "block.minecraft.smooth_stone": "ezigbo okute",
  "block.minecraft.bricks": "brick",
  "block.minecraft.tnt": "dynamite",
  "block.minecraft.bookshelf": "akwụkwọ akwụkwọ",
  "block.minecraft.mossy_cobblestone": "mossy pavement",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "ọwa",
  "block.minecraft.end_rod": "ngwụcha mkpanaka",
  "block.minecraft.chorus_plant": "osisi chorus",
  "block.minecraft.chorus_flower": "chorus ifuru",
  "block.minecraft.purpur_block": "block purpur",
  "block.minecraft.purpur_pillar": "purpur ogidi",
  "block.minecraft.purpur_stairs": "steepụ purpur",
  "block.minecraft.spawner": "pụtarae",
  "block.minecraft.oak_stairs": "akpu nzọụkwụ",
  "block.minecraft.chest": "igbe",
  "block.minecraft.diamond_ore": "diamond ore",
  "block.minecraft.diamond_block": "ngọngọ nke diamond",
  "block.minecraft.crafting_table": "isiokwu crafting",
  "block.minecraft.farmland": "ala oru ubi",
  "block.minecraft.furnace": "furnace",
  "block.minecraft.ladder": "ladder",
  "block.minecraft.rail": "ilzọ ụgbọ elu",
  "block.minecraft.cobblestone_stairs": "ulo cobblestone",
  "block.minecraft.lever": "lever",
  "block.minecraft.stone_pressure_plate": "nkume nrụgide nkume",
  "block.minecraft.oak_pressure_plate": "akpu plate stress",
  "block.minecraft.spruce_pressure_plate": "mpempe akwụkwọ mgbochi",
  "block.minecraft.birch_pressure_plate": "plate strip press",
  "block.minecraft.jungle_pressure_plate": "plate strike ubi",
  "block.minecraft.acacia_pressure_plate": "plate strike acacia",
  "block.minecraft.dark_oak_pressure_plate": "itiri akpu okpokoro",
  "block.minecraft.crimson_pressure_plate": "crimson nrụgide plate",
  "block.minecraft.warped_pressure_plate": "gburugburu nrụgide arụ",
  "block.minecraft.polished_blackstone_pressure_plate": "ọkpụkpụ ejiri blackstone rụpụtara",
  "block.minecraft.redstone_ore": "redstone ore",
  "block.minecraft.redstone_torch": "osimiri redstone",
  "block.minecraft.snow": "snoo",
  "block.minecraft.ice": "plain ice",
  "block.minecraft.snow_block": "ugbo snow",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "efere",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "oak nsu",
  "block.minecraft.spruce_fence": "ogige spruce",
  "block.minecraft.birch_fence": "birch ngere",
  "block.minecraft.jungle_fence": "jungle ngere",
  "block.minecraft.acacia_fence": "acacia ngere",
  "block.minecraft.dark_oak_fence": "ọchịchịrị oak nsu",
  "block.minecraft.crimson_fence": "crimson fence",
  "block.minecraft.warped_fence": "nsu agha kpụ ọkụ n'ọnụ",
  "block.minecraft.pumpkin": "ugu",
  "block.minecraft.carved_pumpkin": "ebube a kụrụ akpụ",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "mkpụrụ obi sand",
  "block.minecraft.soul_soil": "mkpụrụ obi",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "basalt polured",
  "block.minecraft.soul_torch": "mkpụrụ obi torch",
  "block.minecraft.glowstone": "mkpụrụ obi sand",
  "block.minecraft.jack_o_lantern": "jack o'lantern",
  "block.minecraft.oak_trapdoor": "akpu azuuzọ",
  "block.minecraft.spruce_trapdoor": "ekepu ahihia",
  "block.minecraft.birch_trapdoor": "birch ahihia",
  "block.minecraft.jungle_trapdoor": "ohia ahihia",
  "block.minecraft.acacia_trapdoor": "acacia ahihia",
  "block.minecraft.dark_oak_trapdoor": "itiri akpu azuuzọ",
  "block.minecraft.crimson_trapdoor": "crimson trapdoor",
  "block.minecraft.warped_trapdoor": "plọ njem dị warara",
  "block.minecraft.infested_stone": "nkume awara",
  "block.minecraft.infested_cobblestone": "pavement awara",
  "block.minecraft.infested_stone_bricks": "akpụ brik na-agbazi",
  "block.minecraft.infested_mossy_stone_bricks": "akpụ brik bred na-agagharị",
  "block.minecraft.infested_cracked_stone_bricks": "akpụ nkume ndị gbawara agbawa",
  "block.minecraft.infested_chiseled_stone_bricks": "akpụ nkume a pịrị apị",
  "block.minecraft.stone_bricks": "nkume brik",
  "block.minecraft.mossy_stone_bricks": "nkume mossy nkume",
  "block.minecraft.cracked_stone_bricks": "nkume nkume gbawara",
  "block.minecraft.chiseled_stone_bricks": "chiseled nkume brik",
  "block.minecraft.brown_mushroom_block": "brown ero mgbochi",
  "block.minecraft.red_mushroom_block": "red ero mgbochi",
  "block.minecraft.mushroom_stem": "ero nzuzo",
  "block.minecraft.iron_bars": "ogwe ígwè",
  "block.minecraft.chain": "chain",
  "block.minecraft.glass_pane": "ibu aja",
  "block.minecraft.melon": "egwusi",
  "block.minecraft.vine": "vine",
  "block.minecraft.oak_fence_gate": "ọnụ ụzọ ámá oak",
  "block.minecraft.spruce_fence_gate": "spruce nsu nsu",
  "block.minecraft.birch_fence_gate": "ọnụ encezọ encemá birch",
  "block.minecraft.jungle_fence_gate": "ọnụ fzọ encemá ọhịa",
  "block.minecraft.acacia_fence_gate": "ọnụ ụzọ ámá acacia",
  "block.minecraft.dark_oak_fence_gate": "ọchịchịrị oak nsu nsu",
  "block.minecraft.crimson_fence_gate": "crimson fence gate",
  "block.minecraft.warped_fence_gate": "ọnụ ụzọ fence",
  "block.minecraft.brick_stairs": "brik steepụ",
  "block.minecraft.stone_brick_stairs": "nkume nkume nkume",
  "block.minecraft.mycelium": "mycelium",
  "block.minecraft.lily_pad": "lily kedo akwa",
  "block.minecraft.nether_bricks": "nether bricks",
  "block.minecraft.cracked_nether_bricks": "emerela nether brick",
  "block.minecraft.chiseled_nether_bricks": "chiseled nether brick",
  "block.minecraft.nether_brick_fence": "ogige brick nether",
  "block.minecraft.nether_brick_stairs": "ebube brick nether",
  "block.minecraft.enchanting_table": "otu tebụl",
  "block.minecraft.end_portal_frame": "njedebe portal ọgwụgwụ",
  "block.minecraft.end_stone": "ọgwụgwụ nkume",
  "block.minecraft.end_stone_bricks": "ọgwụgwụ nkume brik",
  "block.minecraft.dragon_egg": "akwa egg",
  "block.minecraft.redstone_lamp": "redstone oriọna",
  "block.minecraft.sandstone_stairs": "ulo sandstone",
  "block.minecraft.emerald_ore": "emerald ore",
  "block.minecraft.ender_chest": "ender igbe",
  "block.minecraft.tripwire_hook": "nko nke tripwire",
  "block.minecraft.emerald_block": "ngọngọ nke emerald",
  "block.minecraft.spruce_stairs": "ekepu nzọụkwụ",
  "block.minecraft.birch_stairs": "birch nzọụkwụ",
  "block.minecraft.jungle_stairs": "ubi nzọụkwụ",
  "block.minecraft.crimson_stairs": "ọkpụkpụ crimson",
  "block.minecraft.warped_stairs": "nrịba egwuregwu",
  "block.minecraft.command_block": "iwu block",
  "block.minecraft.beacon": "ogidi",
  "block.minecraft.cobblestone_wall": "nkume nkume",
  "block.minecraft.mossy_cobblestone_wall": "mossy cobblestone mgbidi",
  "block.minecraft.brick_wall": "mgbidi brik",
  "block.minecraft.prismarine_wall": "mgbidi prismarine",
  "block.minecraft.red_sandstone_wall": "red sandstone mgbidi",
  "block.minecraft.mossy_stone_brick_wall": "nkume nkume mosis nkume",
  "block.minecraft.granite_wall": "mgbidi granite",
  "block.minecraft.stone_brick_wall": "nkume nkume nkume",
  "block.minecraft.nether_brick_wall": "neda mgbidi brik",
  "block.minecraft.andesite_wall": "mgbidi andesite",
  "block.minecraft.red_nether_brick_wall": "uhie mgbidi brik neda",
  "block.minecraft.sandstone_wall": "nkume mgbidi",
  "block.minecraft.end_stone_brick_wall": "ọgwụgwụ nkume mgbidi brik",
  "block.minecraft.diorite_wall": "mgbidi diorite",
  "block.minecraft.blackstone_wall": "nwa nkịtị",
  "block.minecraft.polished_blackstone_wall": "nnukwu ojii ojii",
  "block.minecraft.polished_blackstone_brick_wall": "nnukwu mgbidi ojii",
  "block.minecraft.stone_button": "nkume bọtịnụ",
  "block.minecraft.oak_button": "akpu bọtịnụ",
  "block.minecraft.spruce_button": "spruce bọtịnụ",
  "block.minecraft.birch_button": "birch bọtịnụ",
  "block.minecraft.jungle_button": "ubi bọtịnụ",
  "block.minecraft.acacia_button": "acacia bọtịnụ",
  "block.minecraft.dark_oak_button": "itiri akpu bọtịnụ",
  "block.minecraft.crimson_button": "crimson bọtịnụ",
  "block.minecraft.warped_button": "bọtị warped",
  "block.minecraft.polished_blackstone_button": "mee bọtịnụ ojii",
  "block.minecraft.anvil": "anvil",
  "block.minecraft.chipped_anvil": "anvil kwadoro",
  "block.minecraft.damaged_anvil": "anvil mebiri",
  "block.minecraft.trapped_chest": "chest tọrọ atọ",
  "block.minecraft.light_weighted_pressure_plate": "plate predictive light",
  "block.minecraft.heavy_weighted_pressure_plate": "plate predictive ebu arọ juru",
  "block.minecraft.daylight_detector": "onye nchọpụta ìhè",
  "block.minecraft.redstone_block": "ngọngọ nke emerald",
  "block.minecraft.nether_quartz_ore": "nduku",
  "block.minecraft.hopper": "hopper",
  "block.minecraft.chiseled_quartz_block": "chiseled quartz block",
  "block.minecraft.quartz_block": "ngọngọ nke quartz",
  "block.minecraft.quartz_bricks": "nkịtị quartz",
  "block.minecraft.quartz_pillar": "ogidi quartz",
  "block.minecraft.quartz_stairs": "quartz steepụ",
  "block.minecraft.activator_rail": "atorzọ njikwa",
  "block.minecraft.dropper": "tụlee",
  "block.minecraft.white_terracotta": "white terracotta",
  "block.minecraft.orange_terracotta": "orange terracotta",
  "block.minecraft.magenta_terracotta": "magenta terracotta",
  "block.minecraft.light_blue_terracotta": "ìhè blue terracotta",
  "block.minecraft.yellow_terracotta": "edo-edo terracotta",
  "block.minecraft.lime_terracotta": "wayo terracotta",
  "block.minecraft.pink_terracotta": "pink terracotta",
  "block.minecraft.gray_terracotta": "grey terracotta",
  "block.minecraft.light_gray_terracotta": "ìhè gray terracotta",
  "block.minecraft.cyan_terracotta": "cyan terracotta",
  "block.minecraft.purple_terracotta": "pọpụl terracotta",
  "block.minecraft.blue_terracotta": "blue terracotta",
  "block.minecraft.brown_terracotta": "brown terracotta",
  "block.minecraft.green_terracotta": "green terracotta",
  "block.minecraft.red_terracotta": "uhie terracotta",
  "block.minecraft.black_terracotta": "nwa terracotta",
  "block.minecraft.barrier": "ihe mgbochi",
  "block.minecraft.iron_trapdoor": "tragwè trapdoor",
  "block.minecraft.hay_block": "hay bọọlụ",
  "block.minecraft.white_carpet": "white kapeeti",
  "block.minecraft.orange_carpet": "kapeeti oroma",
  "block.minecraft.magenta_carpet": "kapeeti magenta",
  "block.minecraft.light_blue_carpet": "kapeeti anụmanụ na-acha odo odo",
  "block.minecraft.yellow_carpet": "kapeeti edo edo",
  "block.minecraft.lime_carpet": "wayo kapeeti",
  "block.minecraft.pink_carpet": "kapeeti pink",
  "block.minecraft.gray_carpet": "kapeeti agba ntụ",
  "block.minecraft.light_gray_carpet": "carpet light",
  "block.minecraft.cyan_carpet": "cyan carpet",
  "block.minecraft.purple_carpet": "purple carpet",
  "block.minecraft.blue_carpet": "epeepe na-acha anụnụ anụnụ",
  "block.minecraft.brown_carpet": "kaadị aja aja",
  "block.minecraft.green_carpet": "kapeeti green",
  "block.minecraft.red_carpet": "kapeeti uhie",
  "block.minecraft.black_carpet": "kapeeti ojii",
  "block.minecraft.terracotta": "terracotta",
  "block.minecraft.coal_block": "ihe mgbochi nke kol",
  "block.minecraft.packed_ice": "packed ice",
  "block.minecraft.acacia_stairs": "acacia nzọụkwụ",
  "block.minecraft.dark_oak_stairs": "itiri akpu nzọụkwụ",
  "block.minecraft.slime_block": "mpempe slime",
  "block.minecraft.grass_path": "zọ grass",
  "block.minecraft.sunflower": "sunflower",
  "block.minecraft.lilac": "lilac",
  "block.minecraft.rose_bush": "rose bush",
  "block.minecraft.peony": "peony",
  "block.minecraft.tall_grass": "ogologo ahịhịa",
  "block.minecraft.large_fern": "nnukwu fern",
  "block.minecraft.white_stained_glass": "iko na-acha ọcha",
  "block.minecraft.orange_stained_glass": "iko na agba oroma",
  "block.minecraft.magenta_stained_glass": "gilasi nke magenta",
  "block.minecraft.light_blue_stained_glass": "glass lightined glass",
  "block.minecraft.yellow_stained_glass": "gilasi odo acha odo",
  "block.minecraft.lime_stained_glass": "iko lime emechara",
  "block.minecraft.pink_stained_glass": "iri anya isi ala",
  "block.minecraft.gray_stained_glass": "iri na agba",
  "block.minecraft.light_gray_stained_glass": "glass nke agba agba agba",
  "block.minecraft.cyan_stained_glass": "iko cyan",
  "block.minecraft.purple_stained_glass": "iko purple nke nwere ifuru",
  "block.minecraft.blue_stained_glass": "ihu na-acha anụnụ anụnụ",
  "block.minecraft.brown_stained_glass": "gilasi brown",
  "block.minecraft.green_stained_glass": "gilasi green na-agba agba",
  "block.minecraft.red_stained_glass": "iko uhie na-acha uhie uhie",
  "block.minecraft.black_stained_glass": "ibe ojii",
  "block.minecraft.white_stained_glass_pane": "agba ntụpọ",
  "block.minecraft.orange_stained_glass_pane": "glass pane oroma",
  "block.minecraft.magenta_stained_glass_pane": "magenta akara egwuregwu",
  "block.minecraft.light_blue_stained_glass_pane": "light light stained glass pane",
  "block.minecraft.yellow_stained_glass_pane": "agba ntụpọ yellow",
  "block.minecraft.lime_stained_glass_pane": "wayo arụrụ nọchiri anya",
  "block.minecraft.pink_stained_glass_pane": "pink stained glass pane",
  "block.minecraft.gray_stained_glass_pane": "grey stained glass pane",
  "block.minecraft.light_gray_stained_glass_pane": "light grey stained glass pane",
  "block.minecraft.cyan_stained_glass_pane": "cyan stained glass pane",
  "block.minecraft.purple_stained_glass_pane": "gululu nke pụrụ anya",
  "block.minecraft.blue_stained_glass_pane": "igwe eji agba agba agba aja aja",
  "block.minecraft.brown_stained_glass_pane": "agba aja aja gbara agba",
  "block.minecraft.green_stained_glass_pane": "green kwadoro glass ebi ndụ",
  "block.minecraft.red_stained_glass_pane": "uhie glass kwadoro",
  "block.minecraft.black_stained_glass_pane": "nwa agba glass",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "brik prismarine",
  "block.minecraft.dark_prismarine": "ọchịchịrị prismarine",
  "block.minecraft.prismarine_stairs": "prismarine nzọụkwụ",
  "block.minecraft.prismarine_brick_stairs": "biriiki prismarine nzọụkwụ",
  "block.minecraft.dark_prismarine_stairs": "itiri prismarine nzọụkwụ",
  "block.minecraft.sea_lantern": "osisi osisi",
  "block.minecraft.red_sandstone": "red sandstone",
  "block.minecraft.chiseled_red_sandstone": "chiseled red sandstone",
  "block.minecraft.cut_red_sandstone": "bee ucha nkume",
  "block.minecraft.red_sandstone_stairs": "uhie red sandstone",
  "block.minecraft.repeating_command_block": "ikwugharị block iwu",
  "block.minecraft.chain_command_block": "chain command block",
  "block.minecraft.magma_block": "magma ngọngọ",
  "block.minecraft.nether_wart_block": "ebe wart block",
  "block.minecraft.warped_wart_block": "ngọngọ nke wart",
  "block.minecraft.red_nether_bricks": "brick red nether",
  "block.minecraft.bone_block": "ọkpụkpụ block",
  "block.minecraft.structure_void": "nhazi abaghị uru",
  "block.minecraft.observer": "lụrụ",
  "block.minecraft.shulker_box": "igbe shulker",
  "block.minecraft.white_shulker_box": "igbe white shulker",
  "block.minecraft.orange_shulker_box": "igbe oroma shulker",
  "block.minecraft.magenta_shulker_box": "magenta shulker igbe",
  "block.minecraft.light_blue_shulker_box": "ìhè blue shulker igbe",
  "block.minecraft.yellow_shulker_box": "igbe igbe shulker",
  "block.minecraft.lime_shulker_box": "wayo shulker igbe",
  "block.minecraft.pink_shulker_box": "pink shulker igbe",
  "block.minecraft.gray_shulker_box": "igbe grey shulker",
  "block.minecraft.light_gray_shulker_box": "ìhè gray shulker igbe",
  "block.minecraft.cyan_shulker_box": "igbe cyan shulker",
  "block.minecraft.purple_shulker_box": "igbe purple shulker",
  "block.minecraft.blue_shulker_box": "igbe blue shulker",
  "block.minecraft.brown_shulker_box": "igwe blue shulker",
  "block.minecraft.green_shulker_box": "igbe shulker green",
  "block.minecraft.red_shulker_box": "red shulker igbe",
  "block.minecraft.black_shulker_box": "igbe black shulker",
  "block.minecraft.white_glazed_terracotta": "white gbara agba terracotta",
  "block.minecraft.orange_glazed_terracotta": "oroma glazed terracotta",
  "block.minecraft.magenta_glazed_terracotta": "magenta glazed terracotta",
  "block.minecraft.light_blue_glazed_terracotta": "magenta glazed terracotta",
  "block.minecraft.yellow_glazed_terracotta": "yellow glazed terracotta",
  "block.minecraft.lime_glazed_terracotta": "wayo glazed terracotta",
  "block.minecraft.pink_glazed_terracotta": "wayo glazed terracotta",
  "block.minecraft.gray_glazed_terracotta": "grey glazed terracotta",
  "block.minecraft.light_gray_glazed_terracotta": "ìhè agba glazed terracotta",
  "block.minecraft.cyan_glazed_terracotta": "cyan na-egbuke egbuke terracotta",
  "block.minecraft.purple_glazed_terracotta": "pọpụl glazed terracotta",
  "block.minecraft.blue_glazed_terracotta": "blue glazed terracotta",
  "block.minecraft.brown_glazed_terracotta": "agba aja aja glazed terracotta",
  "block.minecraft.green_glazed_terracotta": "green gbara agba terracotta",
  "block.minecraft.red_glazed_terracotta": "green gbara agba terracotta",
  "block.minecraft.black_glazed_terracotta": "black na-egbuke egbuke terracotta",
  "block.minecraft.white_concrete": "na-acha ọcha ihe",
  "block.minecraft.orange_concrete": "oroma lhe",
  "block.minecraft.magenta_concrete": "magenta lhu",
  "block.minecraft.light_blue_concrete": "ìhè blue lhe",
  "block.minecraft.yellow_concrete": "edo-edo lhe",
  "block.minecraft.lime_concrete": "oroma nkịrịsị ihe",
  "block.minecraft.pink_concrete": "pink concrete lhe",
  "block.minecraft.gray_concrete": "agba ntụ lhe",
  "block.minecraft.light_gray_concrete": "ìhè agba ihe",
  "block.minecraft.cyan_concrete": "cyan ihe",
  "block.minecraft.purple_concrete": "pọpụl ihe",
  "block.minecraft.blue_concrete": "bulu concrete",
  "block.minecraft.brown_concrete": "agba aja ihe",
  "block.minecraft.green_concrete": "agba akwụkwọ ndụ ihe",
  "block.minecraft.red_concrete": "uhie uhie ihe",
  "block.minecraft.black_concrete": "nwa ihe",
  "block.minecraft.white_concrete_powder": "na-acha ọcha lhe ntụ ntụ",
  "block.minecraft.orange_concrete_powder": "oroma lhe ntụ ntụ",
  "block.minecraft.magenta_concrete_powder": "magenta lhe ntụ ntụ",
  "block.minecraft.light_blue_concrete_powder": "ìhè blue lhe ntụ ntụ",
  "block.minecraft.yellow_concrete_powder": "edo-edo lhe ntụ ntụ",
  "block.minecraft.lime_concrete_powder": "oroma nkịrịsị lhe ntụ ntụ",
  "block.minecraft.pink_concrete_powder": "pink lhe ntụ ntụ",
  "block.minecraft.gray_concrete_powder": "agba ntụ lhe ntụ ntụ",
  "block.minecraft.light_gray_concrete_powder": "ìhè agba hle ntụ ntụ",
  "block.minecraft.cyan_concrete_powder": "cyan lhe ntụ ntụ",
  "block.minecraft.purple_concrete_powder": "pọpụl lhe ntụ ntụ",
  "block.minecraft.blue_concrete_powder": "bulu lhe ntụ ntụ",
  "block.minecraft.brown_concrete_powder": "agba aja lhu ntụ ntụ",
  "block.minecraft.green_concrete_powder": "agba akwụkwọ ndụ lhe ntụ ntụ",
  "block.minecraft.red_concrete_powder": "uhie lhe ntụ ntụ",
  "block.minecraft.black_concrete_powder": "nwa lhe ntụ ntụ",
  "block.minecraft.turtle_egg": "mbe egg",
  "block.minecraft.dead_tube_coral_block": "ugbo nke coral tubular",
  "block.minecraft.dead_brain_coral_block": "ugbo nke coral oku ụbụrụ",
  "block.minecraft.dead_bubble_coral_block": "ugbo nke coral oku egosipụta",
  "block.minecraft.dead_fire_coral_block": "ugbo nke coral oku ọkụ",
  "block.minecraft.dead_horn_coral_block": "ugbo nke coral oku nwere mpi",
  "block.minecraft.tube_coral_block": "oghere nke coral tubular",
  "block.minecraft.brain_coral_block": "oghere nke coral ụbụrụ",
  "block.minecraft.bubble_coral_block": "oghere nke coral egosipụta",
  "block.minecraft.fire_coral_block": "oghere nke coral ọkụ",
  "block.minecraft.horn_coral_block": "ugbo nke coral oku nwere mpi",
  "block.minecraft.tube_coral": "coral tubular",
  "block.minecraft.brain_coral": "coral ụbụrụ",
  "block.minecraft.bubble_coral": "coral egosipụta",
  "block.minecraft.fire_coral": "coral ọkụ",
  "block.minecraft.horn_coral": "coral nwere mpi",
  "block.minecraft.dead_brain_coral": "nwụrụ anwụ ụbụrụ coral",
  "block.minecraft.dead_bubble_coral": "nwụrụ anwụ afọ coral",
  "block.minecraft.dead_fire_coral": "coral nwụrụ anwụ nwụrụ",
  "block.minecraft.dead_horn_coral": "coral nwụrụ anwụ nwụrụ",
  "block.minecraft.dead_tube_coral": "coral nwụrụ anwụ nwụrụ",
  "block.minecraft.tube_coral_fan": "a na-enwe coral tubular",
  "block.minecraft.brain_coral_fan": "a na-enwe coral ụbụrụ",
  "block.minecraft.bubble_coral_fan": "a na-enwe coral egosipụta",
  "block.minecraft.fire_coral_fan": "a na-enwe coral ọkụ",
  "block.minecraft.horn_coral_fan": "a na-enwe coral mpi",
  "block.minecraft.dead_tube_coral_fan": "nwụrụ anwụ tube nkume coral",
  "block.minecraft.dead_brain_coral_fan": "brain nkume coral nwụrụ anwụ",
  "block.minecraft.dead_bubble_coral_fan": "ọnwụ afọ coral fan",
  "block.minecraft.dead_fire_coral_fan": "nwụrụ anwụ ọkụ nkume coral",
  "block.minecraft.dead_horn_coral_fan": "agụụ mpi coral ofufe",
  "block.minecraft.blue_ice": "blue ice",
  "block.minecraft.conduit": "the na-eduga",
  "block.minecraft.polished_granite_stairs": "ebube granite steepụ",
  "block.minecraft.smooth_red_sandstone_stairs": "ezigbo red sandstone steepụ",
  "block.minecraft.mossy_stone_brick_stairs": "nkume nkume mosis nkume",
  "block.minecraft.polished_diorite_stairs": "ebube diorite steepụ",
  "block.minecraft.mossy_cobblestone_stairs": "mossy cobblestone steepụ",
  "block.minecraft.end_stone_brick_stairs": "end stone brik steepụ",
  "block.minecraft.stone_stairs": "nkume steepụ",
  "block.minecraft.smooth_sandstone_stairs": "ezigbo sandstone steepụ",
  "block.minecraft.smooth_quartz_stairs": "ezigbo quartz steepụ",
  "block.minecraft.granite_stairs": "granite steepụ",
  "block.minecraft.andesite_stairs": "steepụ andesite",
  "block.minecraft.red_nether_brick_stairs": "uhie uhie brik",
  "block.minecraft.polished_andesite_stairs": "ebube a na-egbu mara mma nke andesite",
  "block.minecraft.diorite_stairs": "diorite steepụ",
  "block.minecraft.polished_granite_slab": "ebube granite slab",
  "block.minecraft.smooth_red_sandstone_slab": "ezigbo uhie uhie sandstone slab",
  "block.minecraft.mossy_stone_brick_slab": "nkume nkume mosis nkume",
  "block.minecraft.polished_diorite_slab": "egbu maramara diorite slab",
  "block.minecraft.mossy_cobblestone_slab": "mosis cobblestone slab",
  "block.minecraft.end_stone_brick_slab": "end stone brik slab",
  "block.minecraft.smooth_sandstone_slab": "ezigbo sandstone slab",
  "block.minecraft.smooth_quartz_slab": "ezigbo quartz slab",
  "block.minecraft.granite_slab": "granite slab",
  "block.minecraft.andesite_slab": "okpokoro andesite",
  "block.minecraft.red_nether_brick_slab": "uhie uhie nether brick slab",
  "block.minecraft.polished_andesite_slab": "nkume polish andesite",
  "block.minecraft.diorite_slab": "diorite slab",
  "block.minecraft.scaffolding": "ibeghari ihu",
  "block.minecraft.iron_door": "n'ọnụ ironzọ",
  "block.minecraft.oak_door": "oak orzọ",
  "block.minecraft.spruce_door": "spruce n'ọnụ",
  "block.minecraft.birch_door": "ọrịa birch",
  "block.minecraft.jungle_door": "ogige jungle",
  "block.minecraft.acacia_door": "acacia orzọ",
  "block.minecraft.dark_oak_door": "ọchịchịrị oak",
  "block.minecraft.crimson_door": "crimson door",
  "block.minecraft.warped_door": "ọnụ ụzọ alụ ọgụ",
  "block.minecraft.repeater": "nkume tinyegharịa",
  "block.minecraft.comparator": "onye na-achota nkume",
  "block.minecraft.structure_block": "nhazi usoro",
  "block.minecraft.jigsaw": "ngọngọ jigsaw",
  "item.minecraft.turtle_helmet": "shei shei□□mgbe na ụkwụ:□+2 ekike agha",
  "item.minecraft.scute": "echebe",
  "item.minecraft.iron_shovel": "shogwè shọvel□□mgbe ọnọdụ aka:□+3.5 mmebi mmegide□-3 mwakpo ọsọ",
  "item.minecraft.iron_pickaxe": "pgwè pickaxe□□mgbe ọnọdụ aka:□+3 mmebi mmegide□-2.8 mwakpo ọsọ",
  "item.minecraft.iron_axe": "axgwè axe□□mgbe ọnọdụ aka:□+8 mmebi mmegide□-3.1 mwakpo ọsọ",
  "item.minecraft.flint_and_steel": "nkume na ígwè",
  "item.minecraft.apple": "apụl",
  "item.minecraft.bow": "ta",
  "item.minecraft.arrow": "ta",
  "item.minecraft.coal": "kol",
  "item.minecraft.charcoal": "unyi",
  "item.minecraft.diamond": "daimọn",
  "item.minecraft.iron_ingot": "inggwè ingot",
  "item.minecraft.gold_ingot": "gold ọla",
  "item.minecraft.netherite_ingot": "netherite ingot",
  "item.minecraft.netherite_scrap": "scan netherite",
  "item.minecraft.iron_sword": "gwè mma agha□□mgbe ọnọdụ aka:□+5 mmebi mmegide□-2.4 mwakpo ọsọ",
  "item.minecraft.wooden_sword": "mma agha□□mgbe ọnọdụ aka:□+3 mmebi mmegide□-2.4 mwakpo ọsọ",
  "item.minecraft.wooden_shovel": "osisi shọvelụ□□mgbe ọnọdụ aka:□+1.5 mmebi mmegide□-3 mwakpo ọsọ",
  "item.minecraft.wooden_pickaxe": "osisi pickaxe□□mgbe ọnọdụ aka:□+1 mmebi mmegide□-2.8 mwakpo ọsọ",
  "item.minecraft.wooden_axe": "osisi ax□□mgbe ọnọdụ aka:□+6 mmebi mmegide□-3.2 mwakpo ọsọ",
  "item.minecraft.stone_sword": "nkume nkume□□mgbe ọnọdụ aka:□+4 mmebi mmegide□-2.4 mwakpo ọsọ",
  "item.minecraft.stone_shovel": "nkume nkume□□mgbe ọnọdụ aka:□+2.5 mmebi mmegide□-3 mwakpo ọsọ",
  "item.minecraft.stone_pickaxe": "nkume pickaxe□□mgbe ọnọdụ aka:□+2 mmebi mmegide□-2.8 mwakpo ọsọ",
  "item.minecraft.stone_axe": "nkume ax□□mgbe ọnọdụ aka:□+8 mmebi mmegide□-3.2 mwakpo ọsọ",
  "item.minecraft.diamond_sword": "daimọn mma agha□□mgbe ọnọdụ aka:□+6 mmebi mmegide□-2.4 mwakpo ọsọ",
  "item.minecraft.diamond_shovel": "daimọn shọvelụ□□mgbe ọnọdụ aka:□+4.5 mmebi mmegide□-3 mwakpo ọsọ",
  "item.minecraft.diamond_pickaxe": "daimọn mkpa□□mgbe ọnọdụ aka:□+4 mmebi mmegide□-2.8 mwakpo ọsọ",
  "item.minecraft.diamond_axe": "daimọn ax□□mgbe ọnọdụ aka:□+8 mmebi mmegide□-3 mwakpo ọsọ",
  "item.minecraft.stick": "kọọ",
  "item.minecraft.bowl": "bowl",
  "item.minecraft.mushroom_stew": "egwu stew",
  "item.minecraft.golden_sword": "mma agha ọla edo□□mgbe ọnọdụ aka:□+3 mmebi mmegide□-2.4 mwakpo ọsọ",
  "item.minecraft.golden_shovel": "shọvel ọla edo□□mgbe ọnọdụ aka:□+1.5 mmebi mmegide□-3 mwakpo ọsọ",
  "item.minecraft.golden_pickaxe": "pickaxe ọlaedo□□mgbe ọnọdụ aka:□+1 mmebi mmegide□-2.8 mwakpo ọsọ",
  "item.minecraft.golden_axe": "axe ọla edo□□mgbe ọnọdụ aka:□+6 mmebi mmegide□-3 mwakpo ọsọ",
  "item.minecraft.netherite_sword": "mma agha netherite□□mgbe ọnọdụ aka:□+7 mmebi mmegide□-2.4 mwakpo ọsọ",
  "item.minecraft.netherite_shovel": "shoezaiteite□□mgbe ọnọdụ aka:□+5.5 mmebi mmegide□-3 mwakpo ọsọ",
  "item.minecraft.netherite_pickaxe": "pickaxe nke netherland□□mgbe ọnọdụ aka:□+5 mmebi mmegide□-2.8 mwakpo ọsọ",
  "item.minecraft.netherite_axe": "axiteite netherite□□mgbe ọnọdụ aka:□+9 mmebi mmegide□-3 mwakpo ọsọ",
  "item.minecraft.string": "eriri",
  "item.minecraft.feather": "nku",
  "item.minecraft.gunpowder": "egbe",
  "item.minecraft.wooden_hoe": "osisi hoe□□mgbe ọnọdụ aka:□-3 mwakpo ọsọ",
  "item.minecraft.stone_hoe": "nkume nkume□□mgbe ọnọdụ aka:□-2 mwakpo ọsọ",
  "item.minecraft.iron_hoe": "hogwè hoe□□mgbe ọnọdụ aka:□-1 mwakpo ọsọ",
  "item.minecraft.diamond_hoe": "daimọn hoe□□mgbe ọnọdụ aka:",
  "item.minecraft.golden_hoe": "ọha ọlaedo□□mgbe ọnọdụ aka:□-3 mwakpo ọsọ",
  "item.minecraft.netherite_hoe": "onye hoe□□mgbe ọnọdụ aka:",
  "item.minecraft.wheat_seeds": "mkpụrụ ọka",
  "item.minecraft.wheat": "wheat",
  "item.minecraft.bread": "achịcha",
  "item.minecraft.leather_helmet": "akpụkpọ anụ okpu□□mgbe na ụkwụ:□+1 ekike agha",
  "item.minecraft.leather_chestplate": "akpụkpọ anụ tunic□□mgbe na ahụ:□+3 ekike agha",
  "item.minecraft.leather_leggings": "akpụkpọ anụ akpụkpọ ụkwụ□□mgbe na ụkwụ:□+2 ekike agha",
  "item.minecraft.leather_boots": "akpụkpọ anụ akpụkpọ ụkwụ□□mgbe na ụkwụ:□+1 ekike agha",
  "item.minecraft.chainmail_helmet": "okpu agha chain□□mgbe na ụkwụ:□+2 ekike agha",
  "item.minecraft.chainmail_chestplate": "mgbochi obi chain□□mgbe na ahụ:□+5 ekike agha",
  "item.minecraft.chainmail_leggings": "traụza chain□□mgbe na ụkwụ:□+4 ekike agha",
  "item.minecraft.chainmail_boots": "akpụkpọ ụkwụ chain□□mgbe na ụkwụ:□+1 ekike agha",
  "item.minecraft.iron_helmet": "igwe okpu-igwe□□mgbe na ụkwụ:□+2 ekike agha",
  "item.minecraft.iron_chestplate": "ihe mkpuchi ígwè□□mgbe na ahụ:□+6 ekike agha",
  "item.minecraft.iron_leggings": "leggba irongwè□□mgbe na ụkwụ:□+5 ekike agha",
  "item.minecraft.iron_boots": "bogwè akpụkpọ ụkwụ□□mgbe na ụkwụ:□+2 ekike agha",
  "item.minecraft.diamond_helmet": "okpu aghaz daimọn□□mgbe na ụkwụ:□+3 ekike agha□+2 okike ike",
  "item.minecraft.diamond_chestplate": "daimọn chestplate□□mgbe na ahụ:□+8 ekike agha□+2 okike ike",
  "item.minecraft.diamond_leggings": "leggọn daimọn□□mgbe na ụkwụ:□+6 ekike agha□+2 okike ike",
  "item.minecraft.diamond_boots": "daimọn akpụkpọ ụkwụ□□mgbe na ụkwụ:□+3 ekike agha□+2 okike ike",
  "item.minecraft.golden_helmet": "okpu-agha ọla edo□□mgbe na ụkwụ:□+2 ekike agha",
  "item.minecraft.golden_chestplate": "ihe nchekwa ọla edo□□mgbe na ahụ:□+5 ekike agha",
  "item.minecraft.golden_leggings": "iwu ọla edo□□mgbe na ụkwụ:□+3 ekike agha",
  "item.minecraft.golden_boots": "akpụkpọ ụkwụ ọla edo□□mgbe na ụkwụ:□+1 ekike agha",
  "item.minecraft.netherite_helmet": "helite netherite□□mgbe na ụkwụ:□+3 ekike agha□+3 okike ike□+1 nsogbu ntuchi",
  "item.minecraft.netherite_chestplate": "chestplate netherite□□mgbe na ahụ:□+8 ekike agha□+3 okike ike□+1 nsogbu ntuchi",
  "item.minecraft.netherite_leggings": "legitings netherite□□mgbe na ụkwụ:□+6 ekike agha□+3 okike ike□+1 nsogbu ntuchi",
  "item.minecraft.netherite_boots": "boolu netherite□□mgbe na ụkwụ:□+3 ekike agha□+3 okike ike□+1 nsogbu ntuchi",
  "item.minecraft.flint": "nkume",
  "item.minecraft.porkchop": "ezi ụlọ anụ ọhịa",
  "item.minecraft.cooked_porkchop": "ezi ụlọ esiri esi",
  "item.minecraft.painting": "ihe osise",
  "item.minecraft.golden_apple": "apụl ọla edo",
  "item.minecraft.enchanted_golden_apple": "enchanted ọlaedo apụl",
  "block.minecraft.oak_sign": "oak akara",
  "block.minecraft.spruce_sign": "ntughari ihe",
  "block.minecraft.birch_sign": "akara birch",
  "block.minecraft.jungle_sign": "nbanye ala",
  "block.minecraft.acacia_sign": "ama acacia",
  "block.minecraft.dark_oak_sign": "ọgba ọchịchịrị ọchịchịrị",
  "block.minecraft.crimson_sign": "crimson ịrịba ama",
  "block.minecraft.warped_sign": "warped sign",
  "item.minecraft.bucket": "ịwụ",
  "item.minecraft.water_bucket": "buwụ mmiri",
  "item.minecraft.lava_bucket": "lava ịwụ",
  "item.minecraft.minecart": "ngwongwo",
  "item.minecraft.saddle": "sadulu",
  "item.minecraft.redstone": "nkume ustjá",
  "item.minecraft.snowball": "snowball",
  "item.minecraft.oak_boat": "oak ụgbọ mmiri",
  "item.minecraft.leather": "akpụkpọ anụ",
  "item.minecraft.milk_bucket": "bucket mmiri ara ehi",
  "item.minecraft.pufferfish_bucket": "bọket nke pufferfish",
  "item.minecraft.salmon_bucket": "bucket na-emetụ salmon",
  "item.minecraft.cod_bucket": "bucket na-emetụ usoro ntanetị",
  "item.minecraft.tropical_fish_bucket": "bucket na-emetụ azụ ebe okpomọkụ",
  "item.minecraft.brick": "adobe",
  "item.minecraft.clay_ball": "bọọlụ clay",
  "block.minecraft.dried_kelp_block": "mịrị kelp mgbochi",
  "item.minecraft.paper": "akwụkwọ",
  "item.minecraft.book": "akwụkwọ",
  "item.minecraft.slime_ball": "obere egwuregwu",
  "item.minecraft.chest_minecart": "ngwongwo na obi",
  "item.minecraft.furnace_minecart": "ngwongwo na ọkụ",
  "item.minecraft.egg": "akwa",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "mkpanaka azụ",
  "item.minecraft.clock": "elekere",
  "item.minecraft.glowstone_dust": "nkume ọma ustjá",
  "item.minecraft.cod": "usoro ntanetị",
  "item.minecraft.salmon": "salmọn raw",
  "item.minecraft.tropical_fish": "azụ ebe okpomọkụ",
  "item.minecraft.pufferfish": "pufferfish",
  "item.minecraft.cooked_cod": "usoro ntanetị gwakọtara",
  "item.minecraft.cooked_salmon": "salmọn esiri esi",
  "item.minecraft.ink_sac": "ink nwa",
  "item.minecraft.red_dye": "uhie dai",
  "item.minecraft.green_dye": "agba akwụkwọ ndụ agba",
  "item.minecraft.cocoa_beans": "koko agwa",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "pọpụl dai",
  "item.minecraft.cyan_dye": "cyan agba",
  "item.minecraft.light_gray_dye": "ìhè agba agba",
  "item.minecraft.gray_dye": "agba ntụ",
  "item.minecraft.pink_dye": "pink agba",
  "item.minecraft.lime_dye": "wayo dai",
  "item.minecraft.yellow_dye": "agba odo",
  "item.minecraft.light_blue_dye": "ìhè bulu dai",
  "item.minecraft.magenta_dye": "magenta dai",
  "item.minecraft.orange_dye": "oroma dai",
  "item.minecraft.bone_meal": "ọkpụkpụ nri",
  "item.minecraft.blue_dye": "bulu agba",
  "item.minecraft.brown_dye": "agba aja agba",
  "item.minecraft.black_dye": "nwa agba",
  "item.minecraft.white_dye": "na-acha ọcha dai",
  "item.minecraft.bone": "ọkpụkpụ",
  "item.minecraft.sugar": "sugar",
  "block.minecraft.cake": "achicha",
  "block.minecraft.white_bed": "ihe ndina ọcha",
  "block.minecraft.orange_bed": "ndina oroma",
  "block.minecraft.magenta_bed": "magenta ndina",
  "block.minecraft.light_blue_bed": "ìhè bulu ndina",
  "block.minecraft.yellow_bed": "ihe ndina edo edo",
  "block.minecraft.lime_bed": "wayo ndina",
  "block.minecraft.pink_bed": "pink ndina",
  "block.minecraft.gray_bed": "agba ntụ ndina",
  "block.minecraft.light_gray_bed": "ìhè agba ntụ ndina",
  "block.minecraft.cyan_bed": "ndina cyan",
  "block.minecraft.purple_bed": "ndina pọpụl",
  "block.minecraft.blue_bed": "bulu bed",
  "block.minecraft.brown_bed": "agba aja aja",
  "block.minecraft.green_bed": "ndina agba akwụkwọ ndụ",
  "block.minecraft.red_bed": "ulo uhie",
  "block.minecraft.black_bed": "nwa ndina",
  "item.minecraft.cookie": "kuki",
  "item.minecraft.filled_map": "maapụ□#0",
  "item.minecraft.shears": "kwa osisi",
  "item.minecraft.melon_slice": "otu mpi",
  "item.minecraft.dried_kelp": "achịcha na-acha ahịhịa ndụ",
  "item.minecraft.pumpkin_seeds": "mkpụrụ mkpụrụ ugu",
  "item.minecraft.melon_seeds": "mkpụrụ mịlon",
  "item.minecraft.beef": "anụ nri",
  "item.minecraft.cooked_beef": "ibe anụ",
  "item.minecraft.chicken": "ọkụkọ ọkụkọ",
  "item.minecraft.cooked_chicken": "esie ya ọkụkọ",
  "item.minecraft.rotten_flesh": "anụ ahụ rere ere",
  "item.minecraft.ender_pearl": "ender ọla",
  "item.minecraft.blaze_rod": "ọkụ ọkụ",
  "item.minecraft.ghast_tear": "ghast anya mmiri",
  "item.minecraft.gold_nugget": "ihe ngwurugwu",
  "item.minecraft.nether_wart": "neda wart",
  "item.minecraft.potion": "ugbo ala□enweghị mmetụta",
  "item.minecraft.glass_bottle": "iko karama",
  "item.minecraft.spider_eye": "anya ududo",
  "item.minecraft.fermented_spider_eye": "n'egwuregwu ududo anya",
  "item.minecraft.blaze_powder": "ọkụ ntụ ntụ",
  "item.minecraft.magma_cream": "ude magma",
  "block.minecraft.brewing_stand": "ime biya guzosie",
  "block.minecraft.cauldron": "cauldron",
  "item.minecraft.ender_eye": "anya nke ender",
  "item.minecraft.glistering_melon_slice": "iberi nke ogwu",
  "item.minecraft.bat_spawn_egg": "akwa na-akpọ bat",
  "item.minecraft.bee_spawn_egg": "bee spawn egg",
  "item.minecraft.blaze_spawn_egg": "akwa na-akpọ blaze",
  "item.minecraft.cat_spawn_egg": "nwambat ezigbo cakwa",
  "item.minecraft.cave_spider_spawn_egg": "akwa na-akpọ oside ududo",
  "item.minecraft.chicken_spawn_egg": "akwa na-akpọ ọkpọ",
  "item.minecraft.cod_spawn_egg": "akwa na-akpọ usoro ntanetị",
  "item.minecraft.cow_spawn_egg": "akwa na-akpọ ehi",
  "item.minecraft.creeper_spawn_egg": "akwa na-akpọ creeper",
  "item.minecraft.dolphin_spawn_egg": "akwa na-akpọ dolphin",
  "item.minecraft.donkey_spawn_egg": "akwa na-akpọ inyịnya ibu",
  "item.minecraft.drowned_spawn_egg": "akwa na-akpọ mmiri mmiri",
  "item.minecraft.elder_guardian_spawn_egg": "akwa na-akpọ ndị okenye nche",
  "item.minecraft.enderman_spawn_egg": "akwa na-akpọ enderman",
  "item.minecraft.endermite_spawn_egg": "akwa na-akpọ endermite",
  "item.minecraft.evoker_spawn_egg": "egg na-akpọ onye na-akpọ oku",
  "item.minecraft.fox_spawn_egg": "nkịta ọhịa spawn akwa",
  "item.minecraft.ghast_spawn_egg": "akwa na-akpọ ghast",
  "item.minecraft.guardian_spawn_egg": "akwa na-akpọ onye nche",
  "item.minecraft.hoglin_spawn_egg": "hoglin spawn egg",
  "item.minecraft.horse_spawn_egg": "akwa na-akpọ ịnyịnya",
  "item.minecraft.husk_spawn_egg": "akwa na-akpọ husk",
  "item.minecraft.llama_spawn_egg": "akwa na-akpọ lama",
  "item.minecraft.magma_cube_spawn_egg": "egg na-akpọ magma cube",
  "item.minecraft.mooshroom_spawn_egg": "akwa na-akpọ toadstool",
  "item.minecraft.mule_spawn_egg": "akwa na-akpọ inyinya mule",
  "item.minecraft.ocelot_spawn_egg": "akwa na-akpọ ocelot",
  "item.minecraft.panda_spawn_egg": "panda spawn akwa",
  "item.minecraft.parrot_spawn_egg": "akwa na-akpọ okooko",
  "item.minecraft.phantom_spawn_egg": "akwa na-akpọ uda",
  "item.minecraft.pig_spawn_egg": "akwa na-akpọ ezi",
  "item.minecraft.piglin_spawn_egg": "piglin spawn egg",
  "item.minecraft.pillager_spawn_egg": "akwa akwa",
  "item.minecraft.polar_bear_spawn_egg": "akwa nke na-akpọ okpọ pola",
  "item.minecraft.pufferfish_spawn_egg": "akwa na-akpọ onye nwere nsogbu",
  "item.minecraft.rabbit_spawn_egg": "akwa na-akpọ oke bekee",
  "item.minecraft.ravager_spawn_egg": "akwa na agba egbe",
  "item.minecraft.salmon_spawn_egg": "akwa na-akpọ maka salmon",
  "item.minecraft.sheep_spawn_egg": "akwa na-akpọ atụrụ",
  "item.minecraft.shulker_spawn_egg": "akwa na-akpọ shulker",
  "item.minecraft.silverfish_spawn_egg": "akwa na-akpọ azụ azụ",
  "item.minecraft.skeleton_spawn_egg": "achị na-akpọ okpụkpụ",
  "item.minecraft.skeleton_horse_spawn_egg": "akwa na-akpọ okpụkpụ ịnyịnya",
  "item.minecraft.slime_spawn_egg": "akwa na-akpọ sludge",
  "item.minecraft.spider_spawn_egg": "akwa na-akpọ ududo",
  "item.minecraft.squid_spawn_egg": "akwa na-akpọ squid",
  "item.minecraft.stray_spawn_egg": "akwa na-akpọ wanderer",
  "item.minecraft.strider_spawn_egg": "strider spawn egg",
  "item.minecraft.trader_llama_spawn_egg": "onye ahia llama akwa akwa",
  "item.minecraft.tropical_fish_spawn_egg": "akwa na-akpọ azù ebe okpomọkụ",
  "item.minecraft.turtle_spawn_egg": "akwa na-akpọ nnụnụ",
  "item.minecraft.vex_spawn_egg": "akwa na-akpọ onye omekome ahụ",
  "item.minecraft.villager_spawn_egg": "akwa na-akpọ obịa ahụ",
  "item.minecraft.vindicator_spawn_egg": "akwa na-akpọ onye nchebe",
  "item.minecraft.wandering_trader_spawn_egg": "na-awagharị onye ahia spawn akwa",
  "item.minecraft.witch_spawn_egg": "akwa na-akpọ onye amoosu",
  "item.minecraft.wither_skeleton_spawn_egg": "achị na-akpọ wither okpụkpụ",
  "item.minecraft.wolf_spawn_egg": "akwa na-akpọ anụ ohịa wolf",
  "item.minecraft.zoglin_spawn_egg": "akwa zoglin",
  "item.minecraft.zombie_spawn_egg": "akwa na-akpọ zombie",
  "item.minecraft.zombie_horse_spawn_egg": "akwa na-akpọ zombie ịnyịnya",
  "item.minecraft.zombie_villager_spawn_egg": "akwa na-akpọ zombie obịa ahụ",
  "item.minecraft.zombified_piglin_spawn_egg": "zighara piglin spawn egg",
  "item.minecraft.experience_bottle": "kalama ọ 'na-adọrọ adọrọ",
  "item.minecraft.fire_charge": "ọkụ ọkụ",
  "item.minecraft.writable_book": "akwụkwọ na njedebe",
  "item.minecraft.written_book": "akwụkwọ ederede",
  "item.minecraft.emerald": "emerald",
  "item.minecraft.item_frame": "nkebi ụba",
  "block.minecraft.flower_pot": "ite ifuru",
  "item.minecraft.carrot": "karọt",
  "item.minecraft.potato": "nduku",
  "item.minecraft.baked_potato": "nduku",
  "item.minecraft.poisonous_potato": "nsi na-egbu egbu",
  "item.minecraft.map": "map efu",
  "item.minecraft.golden_carrot": "karọt ọlaedo",
  "block.minecraft.skeleton_skull": "ọkpụkpụ okpokoro isi",
  "block.minecraft.wither_skeleton_skull": "okpokoro isi ọkpụkpụ okpokoro isi",
  "block.minecraft.player_head": "isi player",
  "block.minecraft.zombie_head": "isi zombie",
  "block.minecraft.creeper_head": "isi na-akpụ akpụ",
  "block.minecraft.dragon_head": "isi dragọn",
  "item.minecraft.carrot_on_a_stick": "karọt na mkpisi",
  "item.minecraft.warped_fungus_on_a_stick": "fungus achara na osisi",
  "item.minecraft.nether_star": "neda kpakpando",
  "item.minecraft.pumpkin_pie": "ugu achịcha",
  "item.minecraft.firework_rocket": "igwe ọkụ ọkụ",
  "item.minecraft.firework_star": "igwe ọkụ ọkụ",
  "item.minecraft.enchanted_book": "akwụkwọ enwasị",
  "item.minecraft.nether_brick": "adobe brik",
  "item.minecraft.quartz": "neda quartz",
  "item.minecraft.tnt_minecart": "minecraft with dinamite",
  "item.minecraft.hopper_minecart": "ngwongwo na hopper",
  "item.minecraft.prismarine_shard": "onyediegwu prismarine",
  "item.minecraft.prismarine_crystals": "kristal prismarine",
  "item.minecraft.rabbit": "oke oyibo",
  "item.minecraft.cooked_rabbit": "oke oyibo",
  "item.minecraft.rabbit_stew": "oke oyibo",
  "item.minecraft.rabbit_foot": "kwụ kwụ",
  "item.minecraft.rabbit_hide": "oke oyibo zoro",
  "item.minecraft.armor_stand": "ekike agha guzosie",
  "item.minecraft.iron_horse_armor": "horsnyịnya ebube",
  "item.minecraft.golden_horse_armor": "ezigbo ịnyịnya agha",
  "item.minecraft.diamond_horse_armor": "ebube anyịnya daimọn",
  "item.minecraft.leather_horse_armor": "akpụkpọ anụ ịnyịnya ekike agha",
  "item.minecraft.lead": "aha kpido",
  "item.minecraft.name_tag": "aha kpido",
  "item.minecraft.command_block_minecart": "ngwongwo na iwu gbochie",
  "item.minecraft.mutton": "raw anụmanụ",
  "item.minecraft.cooked_mutton": "anụmanụ esiri esi",
  "block.minecraft.white_banner": "ọkọlọtọ na-acha ọcha",
  "block.minecraft.orange_banner": "ọkọlọtọ oroma",
  "block.minecraft.magenta_banner": "magenta pụrụ iche",
  "block.minecraft.light_blue_banner": "ìhè bulu pụrụ iche",
  "block.minecraft.yellow_banner": "ọkọlọtọ edo-edo",
  "block.minecraft.lime_banner": "wayo pụrụ iche",
  "block.minecraft.pink_banner": "pink pụrụ iche",
  "block.minecraft.gray_banner": "agba ntụ pụrụ iche",
  "block.minecraft.light_gray_banner": "ìhè gray pụrụ iche",
  "block.minecraft.cyan_banner": "banyere cyan",
  "block.minecraft.purple_banner": "pụrụ iche pụrụ iche",
  "block.minecraft.blue_banner": "bulu pụrụ iche",
  "block.minecraft.brown_banner": "agba aja pụrụ iche",
  "block.minecraft.green_banner": "ọkọlọtọ agba akwụkwọ ndụ",
  "block.minecraft.red_banner": "uhie pụrụ iche",
  "block.minecraft.black_banner": "nwa pụrụ iche",
  "item.minecraft.end_crystal": "kwụsị crystal",
  "item.minecraft.chorus_fruit": "mkpụrụ korọs",
  "item.minecraft.popped_chorus_fruit": "mkpụrụ osisi korọs",
  "item.minecraft.beetroot": "anụmanụ",
  "item.minecraft.beetroot_seeds": "mkpụrụ osisi anụmanụ",
  "item.minecraft.beetroot_soup": "anụmanụ ofe",
  "item.minecraft.dragon_breath": "ume dragọn",
  "item.minecraft.splash_potion": "ikwommiri apụghị ulo□enweghị mmetụta",
  "item.minecraft.spectral_arrow": "akụkụ spectral",
  "item.minecraft.tipped_arrow": "ugboro akwadoghị aghara□enweghị mmetụta",
  "item.minecraft.lingering_potion": "na-egbu oge□enweghị mmetụta",
  "item.minecraft.shield": "ọta",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "rugbọ mmiri spruce",
  "item.minecraft.birch_boat": "chgbọ mmiri birch",
  "item.minecraft.jungle_boat": "unggbọ mmiri nke ọhịa",
  "item.minecraft.acacia_boat": "atgbọ mmiri acacia",
  "item.minecraft.dark_oak_boat": "ọchịchịrị akpu gbara ọchịchịrị",
  "item.minecraft.totem_of_undying": "totem nke ekwenye",
  "item.minecraft.shulker_shell": "onyekachi shei",
  "item.minecraft.iron_nugget": "ngwunye irongwè",
  "item.minecraft.knowledge_book": "akwụkwọ ihe ọmụma",
  "item.minecraft.debug_stick": "osisi debug",
  "item.minecraft.music_disc_13": "egwu diski□c418 - 13",
  "item.minecraft.music_disc_cat": "egwu diski□c418 - cat",
  "item.minecraft.music_disc_blocks": "egwu diski□c418 - blocks",
  "item.minecraft.music_disc_chirp": "egwu diski□c418 - chirp",
  "item.minecraft.music_disc_far": "egwu diski□c418 - far",
  "item.minecraft.music_disc_mall": "egwu diski□c418 - mall",
  "item.minecraft.music_disc_mellohi": "egwu diski□c418 - mellohi",
  "item.minecraft.music_disc_stal": "egwu diski□c418 - stal",
  "item.minecraft.music_disc_strad": "egwu diski□c418 - strad",
  "item.minecraft.music_disc_ward": "egwu diski□c418 - ward",
  "item.minecraft.music_disc_11": "egwu diski□c418 - 11",
  "item.minecraft.music_disc_wait": "egwu diski□c418 - wait",
  "item.minecraft.music_disc_pigstep": "egwu diski□lena raine - pigstep",
  "item.minecraft.trident": "trident□□mgbe ọnọdụ aka:□+8 mmebi mmegide□-2.9 mwakpo ọsọ",
  "item.minecraft.phantom_membrane": "phantom akpụkpọ",
  "item.minecraft.nautilus_shell": "nautilus shei",
  "item.minecraft.heart_of_the_sea": "obi nke oké osimiri",
  "item.minecraft.crossbow": "obo",
  "item.minecraft.suspicious_stew": "enyo enyo",
  "block.minecraft.loom": "loom",
  "item.minecraft.flower_banner_pattern": "nerkpụrụ pụrụ iche□ifuru n'aka",
  "item.minecraft.creeper_banner_pattern": "nerkpụrụ pụrụ iche□ihe na-akpụ akpụ nchaji",
  "item.minecraft.skull_banner_pattern": "nerkpụrụ pụrụ iche□ebube okpokoro isi",
  "item.minecraft.mojang_banner_pattern": "nerkpụrụ pụrụ iche□ihe",
  "item.minecraft.globe_banner_pattern": "nerkpụrụ pụrụ iche□ụwa",
  "item.minecraft.piglin_banner_pattern": "nerkpụrụ pụrụ iche□izu",
  "block.minecraft.composter": "ngwakọta",
  "block.minecraft.barrel": "gbọmgbọm",
  "block.minecraft.smoker": "anwụrụ anwụrụ",
  "block.minecraft.blast_furnace": "gbawara ọkụ",
  "block.minecraft.cartography_table": "ihe nkiri isiokwu",
  "block.minecraft.fletching_table": "isiokwu fletching",
  "block.minecraft.grindstone": "okpokoro",
  "block.minecraft.lectern": "ozizi",
  "block.minecraft.smithing_table": "isiokwu smithing",
  "block.minecraft.stonecutter": "nkume okwute",
  "block.minecraft.bell": "mgbịrịgba",
  "block.minecraft.lantern": "na-ejegharị",
  "block.minecraft.soul_lantern": "mkpụrụ obi",
  "item.minecraft.sweet_berries": "bertọ tomato",
  "block.minecraft.campfire": "ogwe ọkụ",
  "block.minecraft.soul_campfire": "mkpụrụ obi campfire",
  "block.minecraft.shroomlight": "ìhè",
  "item.minecraft.honeycomb": "mmanụ a .ụ",
  "block.minecraft.bee_nest": "bee akwu",
  "block.minecraft.beehive": "bee",
  "item.minecraft.honey_bottle": "kalama mmanụ a .ụ",
  "block.minecraft.honey_block": "gbochie mmanụ a .ụ",
  "block.minecraft.honeycomb_block": "ngọngọ mmanụ a honeyụ",
  "block.minecraft.lodestone": "lodestone",
  "block.minecraft.netherite_block": "ogwe nke netherite",
  "block.minecraft.ancient_debris": "nkpọrọ ochie",
  "block.minecraft.target": "ezubere",
  "block.minecraft.crying_obsidian": "ideidi obsidian",
  "block.minecraft.blackstone": "nwa ojii",
  "block.minecraft.blackstone_slab": "blackstone slab",
  "block.minecraft.blackstone_stairs": "owu ojii",
  "block.minecraft.gilded_blackstone": "nwa ojii gilded",
  "block.minecraft.polished_blackstone": "nwa ojii",
  "block.minecraft.polished_blackstone_slab": "blackstone slab",
  "block.minecraft.polished_blackstone_stairs": "nzọ ọkwa blackstone",
  "block.minecraft.chiseled_polished_blackstone": "chiseled polished blackstone",
  "block.minecraft.polished_blackstone_bricks": "brik blọkụ ojii",
  "block.minecraft.polished_blackstone_brick_slab": "blackstone brick slab",
  "block.minecraft.polished_blackstone_brick_stairs": "ntọala blackstone brick",
  "block.minecraft.cracked_polished_blackstone_bricks": "etu brọsh ojii ejirila ya mee",
  "block.minecraft.respawn_anchor": "mpempe respawn",
}
export const ig_ng = items; 
